import * as _logger from './logger';
import * as _util from './utilities';
import * as $ from 'jquery';
import { ValidationError } from 'breeze-client';
import { ToastrService } from 'ngx-toastr';

export class ErrorHandler {
    target: Object;
    toastr: ToastrService;

    constructor(targetObject: Object, private toastrService: ToastrService) {
        this.target = targetObject;
        this.toastr = toastrService;
    }

    handleError(error: { entityErrors: ValidationError[]; message: string }) {
        if (error.entityErrors) {
            error.message = _util.getSaveValidationErrorMessage(error);
        }

        _logger.logError(error.message, null, null /*_system.getModuleId(this.target)*/, true, this.toastr);
        throw error;
    }

    log(message: string, showToast: boolean) {
        _logger.log(message, null, null /*_system.getModuleId(this.target)*/, showToast, this.toastr);
    }
}

export function includeIn(targetObject: Object): ErrorHandler {
    return $.extend(targetObject, new ErrorHandler(targetObject, this.toastr));
}
